import { z } from "zod";

function isValidTimeZone(timeZone: string): boolean {
    try {
        new Intl.DateTimeFormat(undefined, { timeZone });
        return true;
    } catch {
        return false;
    }
}

/** Zod schema for a resolvable IANA time zone identifier (e.g. "America/Vancouver"). */
export const TimeZoneString = z.string().refine(isValidTimeZone, { message: "invalid IANA time zone" });
